import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/auth';

const Notifications = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/parent/notifications', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await api.put(`/parent/notifications/${id}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const getIcon = (type) => {
    const icons = {
      grade: '📊',
      absence: '🚨',
      homework: '📚',
      exam: '📝',
      payment: '💰',
      report: '📄',
      message: '💬',
      default: '🔔',
    };
    return icons[type] || icons.default;
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-[#2C3E50]">🔔 Notifications</h1>
          <p className="text-gray-500">Restez informé de toutes les actualités</p>
        </div>
        <button className="text-sm text-[#E67E22] hover:text-[#D35400] transition">
          Tout marquer comme lu
        </button>
      </div>

      {loading ? (
        <div className="text-center py-8">Chargement...</div>
      ) : notifications.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <p className="text-gray-500">Aucune notification</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.map((notif) => (
            <div key={notif.id} className={`bg-white rounded-xl shadow-md p-4 flex items-start space-x-4 ${!notif.is_read ? 'border-l-4 border-[#E67E22]' : ''}`}>
              <div className="text-2xl">{getIcon(notif.type)}</div>
              <div className="flex-1">
                <p className="font-medium text-[#2C3E50]">{notif.title}</p>
                <p className="text-sm text-gray-500">{notif.message}</p>
                <p className="text-xs text-gray-400 mt-1">{notif.time}</p>
              </div>
              {!notif.is_read && (
                <button
                  onClick={() => markAsRead(notif.id)}
                  className="text-sm text-[#E67E22] hover:text-[#D35400]"
                >
                  Marquer comme lu
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;